import {CheckCircle} from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import {Box} from '@mui/material';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

const UpdatedTablesTooltip = ({tablesUpdatedSuccessfully, tablesNotUpdated}) => {
  return (
    <Box>
      {tablesUpdatedSuccessfully.length > 0 && (
        <Grid container gap={0.5} alignItems="center">
          <CheckCircle sx={{fontSize: 13}} />
          {tablesUpdatedSuccessfully.map(t => t.table).join(', ')}
        </Grid>
      )}

      {tablesNotUpdated.length > 0 && (
        <Grid container gap={0.5} alignItems="center">
          <ErrorIcon sx={{fontSize: 13}} />
          {tablesNotUpdated.map(t => t.table).join(', ')}
        </Grid>
      )}
    </Box>
  );
};

UpdatedTablesTooltip.propTypes = {
  tablesUpdatedSuccessfully: PropTypes.array.isRequired,
  tablesNotUpdated: PropTypes.array.isRequired
};

export default UpdatedTablesTooltip;
